/**
 * API URL-источников.
 *
 * Все ручки требуют авторизации. 404 на toggle/sync/delete = «у тебя нет такого
 * источника» (его удалили в другой вкладке либо он чужой) — на UI нужно
 * перечитать листинг.
 */
import apiReq from 'core/api';
import type {
  AddUrlSourceParams,
  ListUrlSourcesParams,
  UrlSourceDetailed,
  UrlSourceListing,
  UrlSourcesListResponse,
} from './types';

const BASE = 'url/sources';

export const listUrlSources = async (
  params: ListUrlSourcesParams
): Promise<UrlSourcesListResponse> => {
  const qs = new URLSearchParams();
  qs.set('project_id', params.project_id);
  if (params.name != null && params.name !== '') qs.set('name', params.name);
  if (params.is_enabled != null) qs.set('is_enabled', String(params.is_enabled));
  if (params.limit != null) qs.set('limit', String(params.limit));
  if (params.offset != null) qs.set('offset', String(params.offset));
  if (params.sort_column) qs.set('sort_column', params.sort_column);
  if (params.sort_direction) qs.set('sort_direction', params.sort_direction);

  const data = await apiReq<UrlSourcesListResponse>(`${BASE}?${qs.toString()}`);
  return data ?? { count: 0, items: [] };
};

/**
 * Синхронная и долгая ручка: бэк скачивает страницу, парсит, сохраняет.
 * Может занять 15+ секунд на тяжёлых страницах — не таймаутить раньше ~30s.
 */
export const addUrlSource = async (
  body: AddUrlSourceParams
): Promise<UrlSourceDetailed | undefined> => {
  return apiReq<UrlSourceDetailed>(`${BASE}/add`, 'POST', body);
};

export const syncUrlSource = async (id: string): Promise<UrlSourceDetailed | undefined> => {
  return apiReq<UrlSourceDetailed>(`${BASE}/${id}/sync`, 'POST');
};

export const toggleUrlSourceEnabled = async (
  id: string,
  isEnabled: boolean
): Promise<UrlSourceListing | undefined> => {
  return apiReq<UrlSourceListing>(`${BASE}/${id}/toggle-enabled`, 'POST', {
    is_enabled: isEnabled,
  });
};

export const deleteUrlSource = async (id: string): Promise<{ status: string } | undefined> => {
  return apiReq<{ status: string }>(`${BASE}/${id}`, 'DELETE');
};
